// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__22GNq","content":"ManualTimeModal_content__3RAlS"};